module.exports = __webpack_public_path__ + "static/img/fengchao.afe99cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/logo/fengchao.jpg
// module id = 8XMd
// module chunks = 0